import React, { useState, useEffect } from "react";
import { getOrgPlaces } from "../../services";
import { styled } from "@mui/material/styles";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import clsx from "clsx";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TreeView from "@mui/lab/TreeView";
import TreeItem, { treeItemClasses, useTreeItem } from "@mui/lab/TreeItem";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { MoreHoriz } from "@mui/icons-material";
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  Box,
} from "@common-ui/ui";

const ControlledTreeItem = React.forwardRef(function ControlledTreeItem(
  props,
  ref
) {
  const {
    classes,
    className,
    label,
    nodeId,
    icon: iconProp,
    expansionIcon,
    displayIcon,
  } = props;

  const {
    disabled,
    expanded,
    selected,
    focused,
    handleExpansion,
    handleSelection,
    preventSelection,
  } = useTreeItem(nodeId);

  const icon = iconProp || expansionIcon || displayIcon;

  const handleMouseDown = (event) => {
    preventSelection(event);
  };

  const handleExpansionClick = (event) => {
    handleExpansion(event);
  };

  const handleSelectionClick = (event) => {
    handleSelection(event);
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={clsx(className, classes.root, {
        [classes.expanded]: expanded,
        [classes.selected]: selected,
        [classes.focused]: focused,
        [classes.disabled]: disabled,
      })}
      onMouseDown={handleMouseDown}
      ref={ref}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div onClick={handleExpansionClick} className={classes.iconContainer}>
        {icon}
      </div>
      <Typography
        onClick={handleSelectionClick}
        component="div"
        className={classes.label}
      >
        {label}
      </Typography>
    </div>
  );
});

const CustomTreeItem = (props) => (
  <TreeItem ContentComponent={ControlledTreeItem} {...props} />
);

export const PlacesTreeView = ({
  setSelectedPlaceId,
  handleAddSubPlace,
  orgId,
  refresh,
  defaultSelectedPlaceId,
}) => {
  const [placesData, setPlacesData] = useState([]);
  const [currentHover, setCurrentHover] = useState(-1);
  const [expanded, setExpanded] = useState(
    window?.localStorage?.getItem("PLACE_EXPANDED")
      ? JSON.parse(window?.localStorage?.getItem("PLACE_EXPANDED"))
      : []
  );
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);
  async function init() {
    try {
      let orgPlaces = await getOrgPlaces(orgId);
      setPlacesData(orgPlaces);
    } catch (error) {
      alert(error);
    }
  }

  const AddChild = ({ options, selectedIndex, handleClick, nodeId }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClickListItem = (event) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
      // setSelectedIndex(index);
      handleClick(index);
      setAnchorEl(null);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <span>
        <Tooltip title="More actions">
          <IconButton
            size="small"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClickListItem}
          >
            <MoreHoriz size="small" />
          </IconButton>
        </Tooltip>
        <Menu
          id="lock-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "lock-button",
            role: "listbox",
          }}
        >
          {options.map((option, index) => (
            <MenuItem
              key={option}
              selected={index === selectedIndex}
              onClick={(event) => {
                handleAddSubPlace(nodeId);
                handleMenuItemClick(event, index);
              }}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </span>
    );
  };

  const StyledTreeItem = styled(CustomTreeItem)(({ theme }) => ({
    color: theme.palette.text.secondary,
    [`& .${treeItemClasses.content}`]: {
      boxSizing: "border-box",
      // color: theme.palette.text.secondary,
      // borderTopRightRadius: theme.spacing(2),
      // borderBottomRightRadius: theme.spacing(2),
      // paddingRight: theme.spacing(0),
      // width: "100%",
      // fontWeight: theme.typography.fontWeightMedium,
      // // "&.add-icon": {
      // //   opacity: 0,
      // // },
      // "&.Mui-expanded": {
      //   fontWeight: theme.typography.fontWeightRegular,
      // },
      // "&:hover": {
      //   backgroundColor: theme.palette.action.hover,
      // },
      // "&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused": {
      //   backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
      //   color: "var(--tree-view-color)",
      // },
      // [`& .${treeItemClasses.label}`]: {
      //   fontWeight: "inherit",
      //   color: "inherit",
      // },
    },
    // [`& .${treeItemClasses.group}`]: {
    //   marginLeft: 0,
    //   [`& .${treeItemClasses.content}`]: {
    //     paddingLeft: theme.spacing(2),
    //   },
    // },
  }));

  const renderParentNode = (parents) => {
    return parents.map((parent, i) => {
      return (
        <StyledTreeItem
          key={parent.system_id}
          onMouseEnter={() => setCurrentHover(parent.system_id)}
          onMouseLeave={() => setCurrentHover(-1)}
          label={
            <Box sx={{ display: "flex", alignItems: "center", p: 0.5, pr: 0 }}>
              <Box component={LocationOnIcon} color="inherit" sx={{ mr: 1 }} />
              <Typography
                variant="body2"
                sx={{ fontWeight: "inherit", flexGrow: 1 }}
                noWrap
              >
                {parent.name}
              </Typography>
              <Typography
                variant="caption"
                color="inherit"
                className="add-icon"
                sx={{
                  opacity:
                    parent.system_id === currentHover
                      ? 1
                      : defaultSelectedPlaceId === parent.system_id
                      ? 1
                      : 0,
                }}
              >
                <AddChild
                  options={["Add Sub Place"]}
                  nodeId={parent.system_id}
                />
              </Typography>
            </Box>
          }
          nodeId={parent.system_id}
        >
          {renderTree(parent.child_places) || null}
        </StyledTreeItem>
      );
    });
  };

  const renderTree = (nodes) => {
    return Array.isArray(nodes)
      ? nodes.length
        ? nodes.map((node) => (
            <StyledTreeItem
              onMouseEnter={() => setCurrentHover(node.system_id)}
              onMouseLeave={() => setCurrentHover(-1)}
              label={
                <Box
                  sx={{ display: "flex", alignItems: "center", p: 0.5, pr: 0 }}
                >
                  <Box
                    component={LocationOnIcon}
                    color="inherit"
                    sx={{ mr: 1 }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "inherit", flexGrow: 1 }}
                    noWrap
                  >
                    {node.name}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="inherit"
                    className="add-icon"
                    sx={{
                      opacity:
                        node.system_id === currentHover
                          ? 1
                          : defaultSelectedPlaceId === node.system_id
                          ? 1
                          : 0,
                    }}
                  >
                    <AddChild
                      options={["Add Sub Place"]}
                      nodeId={node.system_id}
                    />
                  </Typography>
                </Box>
              }
              key={node.system_id}
              nodeId={node.system_id}
            >
              {renderTree(node.child_places)}
            </StyledTreeItem>
          ))
        : null
      : null;
  };

  return (
    <TreeView
      aria-label="rich object"
      expanded={expanded}
      defaultExpanded={defaultSelectedPlaceId}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      selected={defaultSelectedPlaceId}
      onNodeToggle={(event, nodeIds) => {
        setExpanded(nodeIds);
        window?.localStorage.setItem("PLACE_EXPANDED", JSON.stringify(nodeIds));
      }}
      sx={{
        maxHeight: "60vh",
        // minHeight: 400,
        flexGrow: 1,
        width: "100%",
        overflow: "auto",
      }}
      onNodeSelect={(event, nodeId) => {
        return setSelectedPlaceId(nodeId);
      }}
    >
      {renderParentNode(placesData)}
    </TreeView>
  );
};
